// extracted by mini-css-extract-plugin
export default {"milesChart":"milesStatistics_milesChart__b-C3n","milesChartWithDetails":"milesStatistics_milesChartWithDetails__HHccU","tooltipDot":"milesStatistics_tooltipDot__-ZT-s"};